import {call, put} from 'redux-saga/effects';
import {ISkeletonSaga, skeletonSaga} from '../../apis/skeleton/skeletonSaga';
import {GENERIC_ERROR} from '../../constants/ErrorConstants';
import {HideExtraPayload} from '../../@types/actions';
import {HIDE_ALERT_SUCCESS} from "../../constants/ExtraConstants";
import {HideExtraCall} from "../../apis/user";

function* tryFunction(payload: HideExtraPayload) {
    yield call(HideExtraCall, payload);
    yield put({
        type: HIDE_ALERT_SUCCESS,
        payload: {[`${payload.eventId}-${payload.marketId}@${payload.sbv}-${payload.signId}`]: payload.margin}
    });
}

export function* hideAlertSaga({payload}: { payload: HideExtraPayload }): Generator {
    const sagaPayload: ISkeletonSaga = {
        tryApiCall: {function: tryFunction, payload: payload},
        failedType: GENERIC_ERROR
    };
    yield call(skeletonSaga, sagaPayload);
}